import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';

export const InfoGrid = ({ items }) => (
  <Grid container spacing={2} sx={{ mt: 0.5 }}>
    {items.map(({ label, value }) => (
      <Grid item xs={12} sm={6} md={3} key={label}>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
          {value || value === 0 ? value : '-'}
        </Typography>
      </Grid>
    ))}
  </Grid>
);

InfoGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    })
  ).isRequired,
};
